import { useSearchParams } from '@remix-run/react';

import {
    IN_PAGE_SEARCH_PARAM_KEY,
    IN_PAGE_SEARCH_SORT_BY,
    IN_PAGE_SEARCH_ENABLED_SHOP,
} from '@modules/professional/config/constants';

export const useProfessionalTabSearch = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onParamChange = (paramName: string, paramValue = '') => {
        if (paramValue) {
            searchParams.set(paramName, paramValue);
        } else {
            searchParams.delete(paramName);
        }
        setSearchParams(searchParams, { state: { scroll: false } });
    };

    const onSearchChange = (searchKeyword = '') => {
        onParamChange(IN_PAGE_SEARCH_PARAM_KEY, searchKeyword);
    };

    const onSortChange = (sortBy = '') => {
        onParamChange(IN_PAGE_SEARCH_SORT_BY, sortBy);
    };

    const onShopChange = (enabledShop = '') => {
        if (enabledShop === 'yes') {
            onParamChange(IN_PAGE_SEARCH_ENABLED_SHOP, enabledShop);
        } else {
            onParamChange(IN_PAGE_SEARCH_ENABLED_SHOP);
        }
    };

    return {
        onSearchChange,
        onSortChange,
        onShopChange,
        defaultKeyword: searchParams.get(IN_PAGE_SEARCH_PARAM_KEY) || '',
        defaultSortBy: searchParams.get(IN_PAGE_SEARCH_SORT_BY) || 'popular',
        defaultShop: searchParams.get(IN_PAGE_SEARCH_ENABLED_SHOP) || '',
    };
};
